import { createContext } from 'react'

// Read-only contextual information about the CostSpace Project currently
// selected in CostSpace's AppShell, made available to Estimation pages
// that opt in via useContext(ProjectContext). This is NOT a replacement
// for tenderId/revisionId (still sourced from useParams() everywhere in
// Estimation, unchanged) and carries no setter -- Estimation cannot
// change the CostSpace-selected project, only read it. Value shape is
// whatever CostSpace's AppShell passes as selectedProject (id, name,
// code, contract_value, currency, status, organizations) or null when
// no project is currently selected in CostSpace.
export const ProjectContext = createContext(null)
